export default function UndoIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.62891 18.3101H15.6289C18.3889 18.3101 20.6289 16.0701 20.6289 13.3101C20.6289 10.5501 18.3889 8.31006 15.6289 8.31006H4.62891"
            strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.93109 10.8099L4.37109 8.24994L6.93109 5.68994" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
